/**
 * Utilitários de formatação para UX
 */

/**
 * Formata um número de telefone no padrão brasileiro (XX) XXXXX-XXXX
 * ou (XX) XXXX-XXXX dependendo do tamanho.
 */
export const formatPhone = (value: string): string => {
  if (!value) return '';
  
  // Remove tudo que não for dígito
  let cleaned = value.replace(/\D/g, '');
  
  // Limita a 11 dígitos
  if (cleaned.length > 11) {
    cleaned = cleaned.substring(0, 11);
  }
  
  if (cleaned.length === 0) return '';
  if (cleaned.length <= 2) return `(${cleaned}`;
  if (cleaned.length <= 6) return `(${cleaned.substring(0, 2)}) ${cleaned.substring(2)}`;
  if (cleaned.length <= 10) return `(${cleaned.substring(0, 2)}) ${cleaned.substring(2, 6)}-${cleaned.substring(6)}`;
  
  // Formato para celular com 9 dígitos: (XX) XXXXX-XXXX
  return `(${cleaned.substring(0, 2)}) ${cleaned.substring(2, 7)}-${cleaned.substring(7, 11)}`;
};
